import { render, staticRenderFns } from "./UnUsedList.vue?vue&type=template&id=941c7198&scoped=true&"
import script from "./UnUsedList.vue?vue&type=script&lang=js&"
export * from "./UnUsedList.vue?vue&type=script&lang=js&"
import style0 from "./UnUsedList.vue?vue&type=style&index=0&id=941c7198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941c7198",
  null
  
)

export default component.exports